import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=4cfd0648&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=4cfd0648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd0648",
  null
  
)

export default component.exports